module.exports = __webpack_public_path__ + "static/cv-Valeriya-Kozlova-fr-fc63bb851af859d17770ce1f47429b8e.pdf";